import React, { Component } from "react";
export default class AlternationSection extends Component {
  render() {
    var {
      executive_alternation_trial1,
      executive_alternation_trial2,
      executive_alternation_trial3,
      executive_alternation_trial4,
      executive_alternation_trial5,
      executive_alternation_trial6,
      executive_alternation_trial7,
      executive_alternation_trial8,
      executive_alternation_trial9,
      executive_alternation_trial10,
      executive_alternation_trial11,
      executive_alternation_trial12,
      executive_alternation_score,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-12">
          <hr />
          <ul style={{ paddingLeft: 20, fontSize: 19 }}>
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  If the patient alternates with the letter first and number
                  second (e.g., A-1, B-2, C-3) score as correct if the sequence
                  is retained.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  “I want you to alternate between numbers and letters, starting
                  with 1-A, then 2-B, 3-C, and so on. Please continue from
                  there, alternating between numbers and letters, in order,
                  without skipping any until I tell you to stop”.
                </li>
                <li style={{ listStyle: "circle" }}>
                  “Let’s begin together, Ready: 1-A, 2-B, 3-C...” with the
                  patient and then let them continue the sequence alone.
                </li>
                <li>
                  <br />
                  <table
                    className="answer-table table table-responsive"
                    cellPadding={11}
                  >
                    <tbody>
                      <tr>
                        <th className="trial">Trial</th>
                        <th style={{ minWidth: 57 }}></th>
                        <th>Check</th>
                        <th className="trial">Trial</th>
                        <th style={{ minWidth: 57 }}></th>
                        <th>Check</th>
                        <th className="trial">Trial</th>
                        <th style={{ minWidth: 57 }}></th>
                        <th>Check</th>
                      </tr>
                      <tr>
                        <td className="trial">1</td>
                        <td>4-D</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial1 == "1" ? true : false
                            }
                            name="executive_alternation_trial1"
                          />
                        </td>
                        <td className="trial">2</td>
                        <td>5-E</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial2 == "1" ? true : false
                            }
                            name="executive_alternation_trial2"
                          />
                        </td>
                        <td className="trial">3</td>
                        <td>6-F</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial3 == "1" ? true : false
                            }
                            name="executive_alternation_trial3"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="trial">4</td>
                        <td>7-G</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial4 == "1" ? true : false
                            }
                            name="executive_alternation_trial4"
                          />
                        </td>
                        <td className="trial">5</td>
                        <td>8-H</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial5 == "1" ? true : false
                            }
                            name="executive_alternation_trial5"
                          />
                        </td>
                        <td className="trial">6</td>
                        <td>9-I</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial6 == "1" ? true : false
                            }
                            name="executive_alternation_trial6"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="trial">7</td>
                        <td>10-J</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial7 == "1" ? true : false
                            }
                            name="executive_alternation_trial7"
                          />
                        </td>
                        <td className="trial">8</td>
                        <td>11-K</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial8 == "1" ? true : false
                            }
                            name="executive_alternation_trial8"
                          />
                        </td>
                        <td className="trial">9</td>
                        <td>12-L</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial9 == "1" ? true : false
                            }
                            name="executive_alternation_trial9"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="trial">10</td>
                        <td>13-M</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial10 == "1"
                                ? true
                                : false
                            }
                            name="executive_alternation_trial10"
                          />
                        </td>
                        <td className="trial">11</td>
                        <td>14-N</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial11 == "1"
                                ? true
                                : false
                            }
                            name="executive_alternation_trial11"
                          />
                        </td>
                        <td className="trial">12</td>
                        <td>15-O</td>
                        <td>
                          <input
                            className="position-relative"
                            style={{ width: 20 }}
                            type="checkbox"
                            checked={
                              executive_alternation_trial12 == "1"
                                ? true
                                : false
                            }
                            name="executive_alternation_trial12"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </li>
              </ul>
            </li>
          </ul>
          <hr />
          <div className="col-lg-6">
            <span className="fs-19">Score (0-12) </span>
            <input
              disabled
              type="number"
              name="executive_alternation_score"
              value={executive_alternation_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
